"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const react_1 = __importDefault(require("react"));
const Tabs_elements_1 = require("./Tabs.elements");
const classnames_1 = __importDefault(require("classnames"));
const Tabs = ({ tabs, activeTab, onChange, className, language, }) => {
    return (react_1.default.createElement(Tabs_elements_1.TabsWrap, { className: className }, tabs.map((tab) => (react_1.default.createElement(Tabs_elements_1.Tab, { key: tab.slug, onClick: () => onChange(tab.slug), className: (0, classnames_1.default)({ active: activeTab === tab.slug }) },
        tab.icon,
        react_1.default.createElement("span", null, tab === null || tab === void 0 ? void 0 : tab[`description_${language}`]))))));
};
exports.Tabs = Tabs;
